export const welcomePageTranslations = {
  en: {
    title: 'Welcome',

    hero: {
      headline: 'Mental Well-Being for Everyone in Blaine County',
      body: 'TogetherWe brings people and partners together to build a stronger, more connected mental well-being network — improving access, belonging, and support across Blaine County.',
      cta: 'Learn More',
      logoAlt: 'TogetherWe',
    },

    welcomeSection: {
      title: 'Welcome to Our Online Community',
      p1: 'The TogetherWe online hub makes it easier to explore local resources, discover community events, join groups, and find trusted providers — all in one place.',
      p2: 'You can browse freely, or create an account to personalize your experience, follow groups, and stay connected to what matters to you most.',
      p3: 'One place to connect, find support, and belong.',
      viewOurWork: 'View Our Work',
    },

    quickLinks: {
      title: 'Quick Links',
      signUpLabel: 'Sign Up',
      items: [
        { label: 'News Feed', href: '/news' },
        { label: 'Groups', href: '/groups' },
        { label: 'Mental Health Providers', href: '/providers' },
        { label: 'FAQs', href: '/faqs' },
      ],
    },

    events: {
      title: 'Upcoming Local Events',
      empty: 'No upcoming events yet.',
      attendingShort: 'attending',
    },

    cta: {
      title: 'Create Your Space. Find Your Place.',
      body: 'People use the community hub to find out what’s happening, to connect, participate, and belong to something local.',
      button: 'Sign Up for Free',
      imageAlt: 'TogetherWe community picnic in a park',
    },
  },

  es: {
    title: 'Bienvenido',

    hero: {
      headline: 'Bienestar Mental para Todos en el Condado de Blaine',
      body: 'TogetherWe une a personas y socios para construir una red de bienestar mental más fuerte y conectada, mejorando el acceso, la pertenencia y el apoyo en todo el condado de Blaine.',
      cta: 'Más Información',
      logoAlt: 'TogetherWe',
    },

    welcomeSection: {
      title: 'Bienvenido a Nuestra Comunidad en Línea',
      p1: 'El centro en línea de TogetherWe facilita explorar recursos locales, descubrir eventos comunitarios, unirte a grupos y encontrar proveedores de confianza, todo en un solo lugar.',
      p2: 'Puedes navegar libremente o crear una cuenta para personalizar tu experiencia, seguir grupos y mantenerte conectado con lo que más te importa.',
      p3: 'Un solo lugar para conectarte, encontrar apoyo y pertenecer.',
      viewOurWork: 'Ver Nuestro Trabajo',
    },

    quickLinks: {
      title: 'Enlaces Rápidos',
      signUpLabel: 'Regístrate',
      items: [
        { label: 'Noticias', href: '/news' },
        { label: 'Grupos', href: '/groups' },
        { label: 'Proveedores de Salud Mental', href: '/providers' },
        { label: 'Preguntas Frecuentes', href: '/faqs' },
      ],
    },

    events: {
      title: 'Próximos Eventos Locales',
      empty: 'Aún no hay eventos próximos.',
      attendingShort: 'asistiendo',
    },

    cta: {
      title: 'Crea Tu Espacio. Encuentra Tu Lugar.',
      body: 'Las personas usan el centro comunitario para descubrir qué está pasando, conectar, participar y pertenecer a algo local.',
      button: 'Regístrate Gratis',
      imageAlt: 'Picnic comunitario de TogetherWe en un parque',
    },
  },
} as const;

export type WelcomeLang = keyof typeof welcomePageTranslations;
